module.exports = __webpack_public_path__ + "static/media/28.8f4610c9.jpg";